var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartMeter = function SvgSmartMeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.875,
    d: "M19.74 11H4.26c-.143 0-.26.108-.26.24v6.52c0 .132.117.24.26.24h15.48c.143 0 .26-.108.26-.24v-6.52c0-.132-.117-.24-.26-.24M8.476 13.61v2M19 10V2.28c0-.157-.16-.28-.35-.28H5.35c-.19 0-.35.123-.35.28V10M5 18v3.667c0 .187.16.333.35.333h13.3c.19 0 .35-.146.35-.333V18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.875,
    d: "M15.909 5H8.092C8.04 5 8 5.068 8 5.151V7.85c0 .083.041.151.092.151h7.817c.05 0 .091-.068.091-.151V5.15c0-.083-.041-.151-.091-.151M15.108 12.61l-1.092 2.424c-.04.088 0 .215.073.215h.832v1.354l1.063-2.36c.04-.089 0-.215-.073-.215H15.1v-1.424z"
  })));
};
export default SvgSmartMeter;